import { z } from "zod";
import RefurbishmentTriage from "@/pages/RefurbishmentTriage";
import type { ModuleProps } from "../types";

export const functionalTriageConfig = z.object({
  questions: z.array(z.string()).default([]),
});
export type FunctionalTriageConfig = z.infer<typeof functionalTriageConfig>;

/** Renders the legacy triage page inline. Its own "Continue" button navigates
 * to the next legacy route — full integration with `onComplete` is a follow-up. */
export function FunctionalTriageModule(_props: ModuleProps<FunctionalTriageConfig>) {
  return <RefurbishmentTriage />;
}
